import React from "react";
import CommonCheckbox from "../Checkbox";
import clsx from "clsx";

type Props = {
  label?: string | React.ReactNode;
  labelClassName?: string;
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  wrapperClassName?: string;
};

export default function CheckWithLabel({
  label,
  labelClassName,
  checked,
  onChange,
  wrapperClassName,
}: Props) {
  return (
    <div
      className={clsx([
        "flex gap-1.5 py-1 px-2.5 w-full items-center",
        wrapperClassName,
      ])}
      onClick={() => onChange?.(!checked)}
    >
      <CommonCheckbox checked={checked} />
      <label className={labelClassName}>{label}</label>
    </div>
  );
}
